import {connect}     from 'react-redux';
import langueActions from '../../store/actions/langueActions';
import getTemplates  from '../../store/selectors/getTemplates';
import dataThunks    from '../../store/actions/dataThunks';

const mapStateToProps = (state) => ({
  locale : state.getIn(['langue','locale']),
  lang   : getTemplates(state),
});

const mapDispatchToProps = (dispatch) => ({
  setLangue(lang){
    const newLang = lang === 'en' ? 'fr' : 'en';
    dispatch(langueActions.setLangue(newLang));
  },
  getTemplates() {
    dispatch(dataThunks.getTemplates());
  },
});

const buildController = (component) => connect(mapStateToProps, mapDispatchToProps)(component);

export default buildController;



// WEBPACK FOOTER //
// ./src/organisms/MainMenu/MainMenuController.js